import {
  CurrencyPipe as NgCurrencyPipe,
  isPlatformServer,
} from '@angular/common';
import {
  Inject,
  LOCALE_ID,
  PLATFORM_ID,
  Pipe,
  PipeTransform,
  inject,
} from '@angular/core';
import { FxRateService } from '@univacity/angular/datas';
import { LOCALE } from '@univacity/shared/types';

@Pipe({
  name: 'unCurrency',
  standalone: false,
})
export class CurrencyPipe extends NgCurrencyPipe implements PipeTransform {
  private readonly fx = inject(FxRateService);
  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    @Inject(LOCALE_ID) private locale: LOCALE
  ) {
    super(locale);
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  transform(
    value?: number | string | null | undefined,
    from?: string,
    to?: string | null,
    display:
      | 'code'
      | 'symbol'
      | 'symbol-narrow'
      | string
      | boolean = 'symbol-narrow',
    digitsInfo = '1.0-2',
    locale?: LOCALE
  ): string | null {
    if (!from) return null;
    if (!value && value !== 0) return null;
    if (isPlatformServer(this.platformId)) {
      return super.transform(value, from, display, digitsInfo, locale);
    }
    // return super.transform(value, from, display, digitsInfo, locale);
    return super.transform(
      to
        ? this.fx.convert({
            amount: value as number,
            from: from as string,
            to,
          })
        : value,
      to || from,
      display,
      digitsInfo,
      locale
    );
  }
}
